import React from "react";
import Header from "../parts/header";
import Leftbar from "../parts/leftbar";
import Footer from "../parts/footer";

function Dashboard({ children }) {
  return (
    <div id="dashboard-wrapper">
      <label htmlFor="mobile-nav-toggle" />
      <Header />
      <Leftbar />
      {children}
      <Footer />
    </div>
  );
}

export default Dashboard;
